module.exports = __webpack_public_path__ + "img/HairBoom_Logo_color@2x.8234c5b7.png";